module.exports = __webpack_public_path__ + "img/mockup_taxi@2x.b7c97b25.png";